import React from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import SEO from './SEO'

const PageSEO = ({ title, description, keywords, tags }) => {
  const location = useLocation()
  const { i18n } = useTranslation()
  
  // Default values if not provided
  const defaultTitle = 'Hyunjin Jae | Personal Website'
  const defaultDescription = 'Personal website of Hyunjin Jae, a software developer specializing in web development.'
  const defaultKeywords = 'web development, software developer, React, JavaScript'
  
  return (
    <SEO
      title={title || defaultTitle}
      description={description || defaultDescription}
      keywords={keywords || defaultKeywords}
      tags={tags}
    />
  )
}

export default PageSEO 